import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import VueLazyLoad from 'vue-lazyload'


createApp(App).use(VueLazyLoad).mount("#app");
createApp(App).use(router).mount("#app");
